import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20overhead%20view%20of%20diverse%20fashion%20items%20including%20sneakers%20bags%20accessories%20and%20folded%20garments%20arranged%20in%20a%20circular%20composition%20on%20warm%20charcoal%20grey%20textured%20surface%20dramatic%20spotlight%20from%20center%20creating%20radial%20shadows%20editorial%20photography%20bold%20modern%20aesthetic%20with%20ample%20dark%20space%20for%20text%20overlay&width=1800&height=800&seq=kakobuy-cta-v2-06&orientation=landscape"
        alt="Kakobuy Spreadsheet shopping"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-black/35 to-transparent"></div>

      <div className="relative z-10 max-w-6xl mx-auto px-6 flex flex-col items-start">
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight max-w-xl">
          get the latest spreadsheet links
        </h2>
        <p className="text-white/70 text-sm md:text-base max-w-md mt-6 leading-relaxed">
          Compare trusted sellers and make safer buying decisions with our daily updated links. The <strong className="text-white/90">kakobuy spreadsheet</strong> is your gateway to smarter shopping in 2026.
        </p>
        <a
          href={mainSiteUrl}
          target="_blank"
          rel="noopener nofollow"
          className="whitespace-nowrap inline-flex items-center gap-3 mt-8 px-7 py-3.5 rounded-full bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-all duration-200 cursor-pointer group"
        >
          Buy It Now
          <span className="w-7 h-7 flex items-center justify-center rounded-full bg-white/20 group-hover:bg-white/30 transition-colors">
            <i className="ri-arrow-right-line text-sm"></i>
          </span>
        </a>
      </div>
    </section>
  );
}